import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import {
  useGetUserMasterByIdQuery,
  useUpdateUserMasterMutation,
} from "AppQuries/user/user-master";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useForm } from "react-hook-form";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import Swal from "sweetalert2";
import { message } from "antd";
import { format } from "date-fns";
import { Save } from "react-feather";
import { yupResolver } from "@hookform/resolvers/yup";
import { editUserMasterValidation } from "core/Operations/ValidationSchema/userValidationSchema";
const UserProfile = () => {
  const userData = useSelector(loggedInUser);
  const {
    data: userDetails,
    isFetching,
    isError,
    error,
  } = useGetUserMasterByIdQuery(
    {
      code: userData?.userID,
      companyCode: userData?.companyCode,
    },
    {
      enabled: !!userData?.userID && !!userData?.companyCode,
    }
  ) || [];

  const {
    mutate: updateCompanySetting,
    isPending,
    isError: isUpdateError,
    error: updateError,
  } = useUpdateUserMasterMutation();

  const {
    register,
    watch,
    setValue,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editUserMasterValidation),
  });

  const onSubmit = (data) => {
    const requestData = {
      ...data,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    };

    updateCompanySetting(requestData, {
      onSuccess: (response) => {
        if (response === true) {
          Swal.fire({
            type: "success",
            title: "Updated!",
            text: "Company Settings Updated!",
            confirmButtonClass: "btn btn-success",
          });
        } else {
          Swal.fire({
            title: "Failed",
            text: response.errorMessage || "Something went wrong",
            type: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
            confirmButtonClass: "btn btn-primary",
          });
        }
      },
      onError: (error) => {
        console.log(error);
        message(error.message || "Something went wrong.");
      },
    });
  };

  console.log(watch())

  useEffect(() => {
    if (userDetails?.length > 0) {
      Object.keys(userDetails[0]).forEach((key) => {
        setValue(key, userDetails[0][key]);
      });
    }
  }, [userDetails]);

  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  if (isUpdateError) return <Error404 error={updateError} />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profile</h4>
            <h6>User Profile</h6>
          </div>
        </div>

        <div className="card border-0">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-head"></div>
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg">
                    <ImageWithBasePath
                      src="assets/img/user-profile.png"
                      alt="img"
                      id="blah"
                      width="150px"
                    />
                    {/* <div className="profileupload">
                      <input type="file" id="imgInp" />
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/edit-set.svg"
                          alt="img"
                        />
                      </Link>
                    </div> */}
                  </div>
                  <div className="profile-contentname">
                    <h2>{userData?.userName}</h2>
                    <h4>Updates Your Profile and Personal Details.</h4>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">User Name</label>
                    <input
                      type="text"
                      className={`form-control ${
                        errors?.userName ? "is-invalid" : ""
                      }`}
                      {...register("userName", {
                        required: "Enter User Name",
                      })}
                    />
                    {errors?.userName && (
                      <div className="invalid-feedback">
                        {errors?.userName?.message || "Invalid input"}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Password</label>
                    <input
                      type="text"
                      className={`form-control ${
                        errors?.password ? "is-invalid" : ""
                      }`}
                      {...register("password")}
                    />
                    {errors?.userName && (
                      <div className="invalid-feedback">
                        {errors?.password?.message || "Invalid input"}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isPending}
                    >
                      {isPending ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2" />
                          Loading...
                        </>
                      ) : (
                        <>
                          <Save className="me-2" />
                          Update
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
